<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addClassToGroupModal"
            >
              <i class="fas fa-plus ms-1"></i>
              أضف فصل للمجموعة
            </button>
            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addClassToGroupModal"
              tabindex="-1"
              aria-labelledby="addClassToGroupModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة فصل</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="addClassToGroup($event)">
                      <div class="row">
                        <!-- className -->
                        <!-- className -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="className">اسم الفصل</label>
                            <input
                              type="text"
                              id="className"
                              class="form-control"
                              placeholder="اسم الفصل"
                              v-model="newClass.title"
                              required
                            />
                          </div>
                        </div>
                        <!-- Class Description -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="classDescription">وصف الفصل</label>
                            <textarea
                              id="classDescription"
                              cols="30"
                              rows="5"
                              class="form-control"
                              placeholder="وصف الفصل"
                              v-model="newClass.description"
                            ></textarea>
                          </div>
                        </div>
                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn w-100 add">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal Start -->
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <table v-show="this.classes.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit" scope="col">الرقم</th>
                  <th scope="col">اسم الفصل</th>
                  <th scope="col">وصف الفصل</th>
                  <th scope="col">عدد الطلاب</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(classRow, index) in this.classes" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ classRow.title }}</td>
                  <td>{{ classRow.description }}</td>
                  <td>{{ classRow.students_count }}</td>
                  <td>
                    <div class="control">
                      <router-link
                        :to="{
                          name: 'StudentsOfClass',
                          params: { id: classRow.class_id },
                        }"
                        class="btn students"
                      >
                        <img
                          class="img-invert ms-2"
                          src="@/assets/login-icon/users-solid.svg"
                          alt="Students"
                        />
                        الطلاب
                      </router-link>
                      <button
                        class="btn me-2 edit"
                        data-bs-toggle="modal"
                        data-bs-target="#EditClasssModal"
                        @click="this.getSelectClass(classRow.class_id)"
                      >
                        <i class="fas fa-edit ms-2"></i>
                        تعديل
                      </button>

                      <div
                        class="modal fade"
                        tabindex="-1"
                        id="EditClasssModal"
                        aria-labelledby="EditClasssModalLabel"
                        data-bs-backdrop="static"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-body text-end">
                              <div class="text-start">
                                <button
                                  type="button"
                                  class="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <form @submit.prevent="updateSelectClass($event)">
                                <div class="row">
                                  <!-- className -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="className">اسم الفصل</label>
                                      <input
                                        type="text"
                                        id="className"
                                        class="form-control"
                                        placeholder="اسم الفصل"
                                        v-model="updatedClass.title"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <!-- Class Description -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="classDescription"
                                        >وصف الفصل</label
                                      >
                                      <textarea
                                        id="classDescription"
                                        cols="30"
                                        rows="5"
                                        class="form-control"
                                        placeholder="وصف الفصل"
                                        v-model="updatedClass.description"
                                      ></textarea>
                                    </div>
                                  </div>

                                  <!-- Buttons -->
                                  <div class="col-12">
                                    <div class="form-group text-start mt-4">
                                      <button
                                        data-bs-dismiss="modal"
                                        class="btn w-100 edit"
                                      >
                                        تعديل
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        class="btn me-2 delete"
                        @click="deleteSelectedClass(classRow.class_id, index)"
                      >
                        <i class="fas fa-trash-alt ms-2"></i>
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.classes) || this.classes.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">
                لا يوجد فصول داخل المجموعة حتى الآن
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      // Loading
      isloading: true,
      // Group id
      groupId: this.$route.params.id,
      classes: [],
      classList: [],
      currentView: "فصول المجموعة",
      updatedClass: {
        groups: [this.$route.params.id],
      },
      newClass: {
        title: "",
        description: "",
        students_count: 0,
        groups: [this.$route.params.id],
      },
    };
  },
  methods: {
    ...mapActions("groupsModule", [
      "getGroupClasses",
      "addClassToSelectedGroup",
      "updateClassToSelectGroup",
    ]),
    ...mapActions("classesModule", [
      "fetchClasses",
      "updateClass",
      "getClassById",
      "addClass",
      "deleteClass",
    ]),

    async getClassesOfGroup() {
      this.classes = await this.getGroupClasses(this.groupId);
    },

    async addClassToGroup(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      if (this.classes.length == undefined) {
        this.addClassToSelectedGroup();
        console.log("undefined");
      }
      this.addClass(this.newClass);
      closeButton.click();
      this.clearAndShowSuccess("لقد تم الاضافة بنجاح");
    },

    deleteSelectedClass(id, index) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الفصل؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteClass(id);
          this.classes.splice(index, 1);
        }
      });
    },

    // Default Functions
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },

    async getSelectClass(id) {
      await this.getClassById(id);
      this.updatedClass = this.getUpdateClass;
    },

    updateSelectClass(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.updateClass(this.updatedClass);

      const findIndex = this.classes.findIndex(
        (classs) => classs.class_id == this.updatedClass.class_id
      );
      closeButton.click();
      this.classes[findIndex] = this.updatedClass;

      this.clearAndShowSuccess("تم التعديل بنجاح");
    },

    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.newClass = {
        title: "",
        description: "",
        students_count: 0,
        groups: [this.$route.params.id],
      };
    },
  },
  async created() {
    await this.getClassesOfGroup();
    if (this.isFirstLoad) await this.fetchClasses();
    else this.classList = this.getClasses;
  },
  computed: {
    ...mapGetters("groupsModule", ["getClassesOfGroups", "isLoading"]),
    ...mapGetters("classesModule", [
      "getClasses",
      "getUpdateClass",
      "isFirstLoad",
    ]),
  },
  mounted() {
    this.classes = this.getClassesOfGroups;
    this.classList = this.getClasses;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
    getClassesOfGroups() {
      this.classes = this.getClassesOfGroups;
    },
    getClasses() {
      this.classList = this.getClasses;
    },
    isFirstLoad() {
      this.isfirstLoad = this.isFirstLoad;
    },
  },
};
</script>

<style>
</style>